import { render, staticRenderFns } from "./StatusVideos.vue?vue&type=template&id=51452c5c&scoped=true&"
import script from "./StatusVideos.vue?vue&type=script&lang=js&"
export * from "./StatusVideos.vue?vue&type=script&lang=js&"
import style0 from "./StatusVideos.vue?vue&type=style&index=0&id=51452c5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51452c5c",
  null
  
)

export default component.exports